import { createRouter, createWebHashHistory } from 'vue-router'
import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import Sims from '../views/Sims.vue'
import InternetRenewals from '../views/InternetRenewals.vue'
import Users from '../views/Users.vue'
import Login from '../views/Login.vue'
import Home from '../views/Home.vue'
import Statistics from '../views/Statistics.vue'
import Test from '../views/Test.vue'
import Test2 from '../views/Test2.vue'
import Teams from '../views/Teams.vue'
import Employee from '../views/Employee.vue'
import news from '../views/news.vue'
import AccessDenied from '../views/AccessDenied.vue'
import {
  evaluateEnvironmentAccess,
  SECURITY_REASONS
} from '../utils/securityPolicy'
import { evaluateTiwAdminAccess } from '../services/adminDirectory'

let initialAuthResolved = false
let pendingAuthPromise = null

function waitForInitialAuthState() {
  if (initialAuthResolved) {
    return Promise.resolve(firebase.auth().currentUser)
  }

  if (!pendingAuthPromise) {
    pendingAuthPromise = new Promise((resolve) => {
      const unsubscribe = firebase.auth().onAuthStateChanged(
        (user) => {
          initialAuthResolved = true
          unsubscribe()
          resolve(user)
        },
        () => {
          initialAuthResolved = true
          unsubscribe()
          resolve(null)
        }
      )
    }).finally(() => {
      pendingAuthPromise = null
    })
  }

  return pendingAuthPromise
}

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: true }
  },
  {
    path: '/Sims',
    name: 'Sims',
    component: Sims,
    meta: { requiresAuth: true }
  },
  {
    path: '/InternetRenewals',
    name: 'InternetRenewals',
    component: InternetRenewals,
    meta: { requiresAuth: true }
  },
  {
    path: '/Login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false }
  },
  {
    path: '/AccessDenied',
    name: 'AccessDenied',
    component: AccessDenied,
    meta: { requiresAuth: false }
  },
  {
    path: '/Statistics',
    name: 'Statistics',
    component: Statistics,
    meta: { requiresAuth: true }
  },
  {
    path: '/Users',
    name: 'Users',
    component: Users,
    meta: { requiresAuth: true }
  },
  {
    path: '/Test',
    name: 'Test',
    component: Test,
    meta: { requiresAuth: true }
  },
  {
    path: '/Teams',
    name: 'Teams',
    component: Teams,
    meta: { requiresAuth: true }
  },
  {
    path: '/Employee',
    name: 'Employee',
    component: Employee,
    meta: { requiresAuth: true, requiresSuperAdmin: true }
  },
  {
    path: '/Test2',
    name: 'Test2',
    component: Test2,
    meta: { requiresAuth: true }
  },
  {
    path: '/news',
    name: 'news',
    component: news,
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to) => {
  const environmentDecision = evaluateEnvironmentAccess()

  if (!environmentDecision.allowed && to.name !== 'AccessDenied') {
    return {
      name: 'AccessDenied',
      query: { reason: environmentDecision.reason }
    }
  }

  const authUser = firebase.auth().currentUser || await waitForInitialAuthState()

  if (to.meta.requiresAuth && !authUser) {
    return {
      name: 'Login',
      query: { redirect: to.fullPath }
    }
  }

  if (authUser) {
    const userDecision = await evaluateTiwAdminAccess(authUser.email)

    if (!userDecision.allowed) {
      await firebase.auth().signOut().catch(() => {})

      if (to.name !== 'AccessDenied') {
        return {
          name: 'AccessDenied',
          query: { reason: userDecision.reason }
        }
      }
    }

    if (to.meta.requiresSuperAdmin && userDecision.role !== 'superadmin') {
      return {
        name: 'AccessDenied',
        query: { reason: SECURITY_REASONS.SUPERADMIN_REQUIRED }
      }
    }

    if (to.name === 'Login') {
      return {
        name: 'Home'
      }
    }
  }

  if (environmentDecision.allowed && to.name === 'AccessDenied' && !to.query.reason) {
    return authUser ? { name: 'Home' } : { name: 'Login' }
  }

  return true
})

export default router
